import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { Select } from "baseui/select";

const BacnetPropertyMappingCustomMapperForm = ({ converter, onConverterChange, converterParams, onConverterParamsChange }) => {
    const onConverterChanged = (e: any) => onConverterChange(e.value);
    const onConverterParamsChanged = (e: any) => onConverterParamsChange(e.target.value);

    const selectedPropertyMapper = converter && converter.length >= 1 ? converter[0] : undefined;

    return (<>
        <FormControl
            label={() => "Mapper"}
            caption={() => "Select a mapper to use or leave empty for default mapper"}
        >
            <Select
                options={converters}
                value={converter}
                placeholder="Select mapper"
                onChange={onConverterChanged}
            />
        </FormControl>
        {(selectedPropertyMapper && selectedPropertyMapper.hasParameters) &&
            <FormControl
                label={() => "Parameters"}
                caption={() => selectedPropertyMapper.parametersDescription ?? "Enter custom mapper parameters in JSON format {\"factor\":0.1}"}
            >
                <Input value={converterParams} onChange={onConverterParamsChanged} placeholder="Enter mapper parameters ..." />
            </FormControl>
        }
    </>
    )
}

const converters = [
    { label: "Inverse Mapper", id: 0,  fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.InverseBacnetPropertyMapper", hasParameters: false, },
    { label: "Unit Mapper", id: 1,  fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.UnitBacnetPropertyMapper", hasParameters: false, },
    { label: "Read Mapper", id: 2,  fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.ReadBacnetPropertyMapper", hasParameters: false, },
    { label: "Write Mapper", id: 3,  fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.WriteBacnetPropertyMapper", hasParameters: false, },
    { label: "Trigger Mapper", id: 4,  fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.TriggerBacnetPropertyMapper", hasParameters: false, },
    { label: "Converter Read Mapper", id: 5, hasParameters: true, fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.ConverterReadBacnetPropertyMapper" },
    { label: "Converter Write Mapper", id: 6,  fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.ConverterWriteBacnetPropertyMapper", hasParameters: true, },
    { label: "Multistate Mapper", id: 7,  fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.MultistateBacnetPropertyMapper", hasParameters: true, parametersDescription: "Leave Empty for default 1to1 mapping or enter custom mapper parameters in JSON format {\"ValuesMapping\":{\"1\":2,\"2\":3},\"InverseValuesMapping\":{\"2\":1,\"3\":2}}" },
    { label: "evon - Aggregate Man On", id: 8,  fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.evonAggregateManBacnetPropertyMapper", hasParameters: false, },
    { label: "Read Int --> Binary Mapper", id: 9, fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.ReadIntegerToBinaryBacnetPropertyMapper",hasParameters: true, parametersDescription: "Enter custom mapper parameters in JSON format {\"bit\":1}"   },
    { label: "Boolean to Int Mapper", id: 10, fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.BooleanToIntBacnetPropertyMapper",hasParameters: true, parametersDescription: "Enter custom mapper parameters in JSON format {\"FalseValue\":1, \"TrueValue\":2}"   },
    { label: "Int to Boolean Mapper", id: 11, fullName: "AutomationApps.Mappings.BACnet.PropertyMappers.IntToBooleanBacnetPropertyMapper",hasParameters: true, parametersDescription: "Enter custom mapper parameters in JSON format {\"value\":1, \"isReadOnly\":true}"   },
];


export default BacnetPropertyMappingCustomMapperForm;